import React from 'react';
export function OfferSection() {
  return <section id="oferta" className="py-6 md:py-9 px-5 bg-gradient-to-b from-dark-bg to-card-bg text-center" data-id="element-116" data-mp="3p50gypvem1pn">
      <div className="max-w-[900px] mx-auto" data-id="element-117" data-mp="8nf0lpni0jpk">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-118" data-mp="8mn4mdpzojyr">
          La inversión
        </span>

        <h2 className="font-heading font-black mb-3 text-[23px]" data-id="element-119" data-mp="idi10awy8zxx">
          Todo lo que necesitas para
          <br data-id="element-120" data-mp="meaczbx7hixw" />
          <span className="text-gradient-magenta" data-id="element-121" data-mp="mds8xt4ay0ff">
            interrumpir el ciclo — hoy
          </span>
        </h2>

        {/* Oferta única: Material completo */}
        <div className="max-w-[550px] mx-auto mt-3" data-id="element-122" data-mp="wczo8lulk556">
          <div className="w-full text-left rounded-2xl p-4 md:p-5 border-2 border-magenta-bright shadow-[0_0_30px_rgba(255,45,155,0.2)] bg-card-bg" data-id="element-123" data-mp="wchhuwe80ajj">
            <div className="flex items-center gap-3 md:gap-4" data-id="element-124" data-mp="2y44a119umbhl">
              <img src="https://cdn.magicpatterns.com/uploads/nUWyyPbZ7aDfK6bz3rgm2Q/Captura_de_pantalla_2026-05-21_115413.png" alt="Colección Placer, Culpa y Vacío — 4 volúmenes" className="w-[110px] md:w-[150px] h-auto shrink-0 drop-shadow-[0_6px_20px_rgba(194,0,111,0.45)]" data-id="element-125" data-mp="2y6gqf9zykdsj" />

              <div className="flex-1 min-w-0" data-id="element-126" data-mp="ownayrvissyv">
                <h3 className="font-heading font-black text-[1rem] md:text-[1.2rem] text-white leading-tight" data-id="element-127" data-mp="oxyfitwsi4r1">
                  ⚡ MATERIAL COMPLETO - FORMATO DIGITAL
                </h3>
                <p className="text-white/60 text-[0.8rem] mt-1 leading-snug" data-id="element-128" data-mp="1gnt42octpqen">
                  4 volúmenes PDF + 3 Bonos de regalo
                </p>

                <div className="flex items-baseline gap-2.5 mt-2" data-id="element-129" data-mp="17mv7us8mmn6m">
                  <p className="text-white/40 text-[0.8rem] line-through" data-id="element-130" data-mp="17opi9cm9uwwg">
                    $39.990
                  </p>
                  <p className="font-heading font-black text-[1.5rem] md:text-[1.85rem] text-magenta-bright leading-none" data-id="element-131" data-mp="3sd3u3s1ctez3">
                    usd $22
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="max-w-[550px] mx-auto mt-5" data-id="element-132" data-mp="2lc5zqrz8nfl">
          <a href="https://placer-culpa-y-vacio.impultienda.ar/checkout" className="block text-center w-full bg-gradient-to-br from-magenta to-magenta-bright text-white font-heading font-black text-[1.15rem] md:text-[1.3rem] py-5 px-5 rounded-2xl uppercase tracking-[1px] shadow-[0_8px_30px_rgba(194,0,111,0.5),0_0_60px_rgba(194,0,111,0.2)] transition-[transform,box-shadow] duration-300 hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(194,0,111,0.7),0_0_80px_rgba(194,0,111,0.3)]" data-id="element-133" data-mp="3ksjg5wrkw4hv">
            {'S\xCD, QUIERO EL MATERIAL COMPLETO'}
          </a>

          <p className="text-white/70 text-[0.9rem] font-heading font-semibold mt-4" data-id="element-134" data-mp="2s5p0re9mbvb9">
            🌎 Pagás en la moneda de tu país
          </p>

          <div className="flex justify-center mt-2" data-id="element-135" data-mp="2x5jqhehnqeuq">
            <img src="https://cdn.magicpatterns.com/uploads/iAwRVcP6c5wjxBYiWFb4cu/descarga.png" alt="Métodos de pago: Visa, Mastercard, Mercado Pago" className="h-[32px] md:h-[38px] w-auto object-contain opacity-70" data-id="element-136" data-mp="2dj00393mrc3a" />
          </div>

          <p className="text-white/50 text-[0.95rem] italic mt-3 leading-relaxed" data-id="element-137" data-mp="2igs1quu2ucko">
            La opción más elegida por quienes quieren
            <br className="hidden sm:block" data-id="element-138" data-mp="2weykt4uda80a" /> recuperarse de verdad
          </p>
        </div>

        {/* Trust Badges */}
        <div className="max-w-[550px] mx-auto mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-[0.85rem] text-white/60" data-id="element-139" data-mp="366mfrfq4u76i">
          <span className="flex items-center gap-2" data-id="element-140" data-mp="318kmy32wmthu">
            <span className="text-magenta-bright" data-id="element-141" data-mp="319vri546c5a0">🔒</span> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-142" data-mp="3f57wr6fyhe56">
            <span className="text-magenta-bright" data-id="element-143" data-mp="3a990yxsastuq">⏱️</span> Acceso inmediato
          </span>
        </div>
        <div className="max-w-[550px] mx-auto mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[0.8rem] text-white/40" data-id="element-144" data-mp="18hyzxjsewirk">
          <span className="flex items-center gap-1.5" data-id="element-145" data-mp="1dfs7oh9d5kty">🛡️ Pago protegido</span>
          <span data-id="element-146" data-mp="1i9n0qbauzc5p">•</span>
          <span className="flex items-center gap-1.5" data-id="element-147" data-mp="1ib7kd5vmxaos">📦 Sin suscripción</span>
        </div>
      </div>
    </section>;
}